module.exports = __webpack_public_path__ + "img/wx_.15a2d7ef.png";